import * as React from 'react';
import postData from 'Utils/PostData';
import getQueryStringParams from 'Utils/GetQueryStringParams';

// Assets
import '../Assets/LoginPage.sass';

// Components
import Navbar from '../../../Layout/Common/Components/Navbar';

interface ILoginPageProps {
    history: any;
    location: any;
}

export default class LoginPage extends React.Component<ILoginPageProps, {}> {
    private handleLogin = (e) => {
        e.preventDefault();
        const data = Array.prototype.slice
            .call(e.target)
            .filter(el => el.name)
            .reduce((form, el) => ({
                ...form,
                [el.name]: el.value,
            }), {});
        data['app'] = true;
        postData(
            '/accounts/login/',
            data,
            'application/x-www-form-urlencoded')
            .then(response => {
                if (!response.error) {
                    let queryStringParams = getQueryStringParams(this.props.location.search);
                    window.location.href = 'next' in queryStringParams ? queryStringParams['next'] : '/frontend/courseware/courseslist/';
                }
            })
            .catch(err => console.error(err));
    }

    private handleSignUp = () => {
        // TODO: Will use 'Link' once sign-up page is in new react
        window.location.href = '/accounts/signup/';
    }

    public render() {
        return <div className='login-page-component'>
            <Navbar navbarClass='navbar-dark fixed-top'/>
            <div className='login-page-container'>
                <div className='login-form-container'>
                    <div className='flex-1'></div>
                    <div className='flex-1'>
                        <span className='login-form-logo'>BodhiTree</span>
                        <form className='login-form form' onSubmit={this.handleLogin}>
                            <input name='username' placeholder='email' />
                            <input name='password' type='password' placeholder='password' />
                            <div className='login-button-row'>
                                <button className='login-signup-button' type='submit'>Log In</button>
                                <a href='#'>Forgot password?</a>
                            </div>
                        </form>
                    </div>
                    <div className='sign-up-row flex-1'>
                        <span className='sign-up-text'>Don't have an account?</span>
                        <button className='login-signup-button' onClick={this.handleSignUp}>Sign Up</button>
                    </div>
                </div>
            </div>
        </div>;
    }
}
